import { Tooltip, Typography, type TypographyProps } from '@mui/material';
import { type FC, type RefObject, useEffect, useRef, useState } from 'react';

const useTextOverflow = (text: string): { ref: RefObject<HTMLElement>; isOverflowing: boolean } => {
  const ref = useRef<HTMLElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (element === null) return;

    const isTextOverflowing = element.scrollWidth > element.clientWidth;
    setIsOverflowing(isTextOverflowing);
  }, [text]);

  return { ref, isOverflowing };
};

type Props = TypographyProps & {
  text: string;
};

export const TypographyWithTooltip: FC<Props> = ({ children, text, ...props }) => {
  const { ref, isOverflowing } = useTextOverflow(text);

  return (
    <Tooltip title={isOverflowing ? text : ''}>
      <Typography
        ref={ref}
        {...props}
        sx={{ ...props.sx, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};
